import RsaHomeConsegne from "./pages/RsaHomeConsegnePage.vue";

export default{RsaHomeConsegne}